module.exports = __webpack_public_path__ + "img/91.a47006ba.jpg";